import { createContext } from 'preact';
import type { SetStateAction } from 'preact/compat';
import type { Dispatch } from 'preact/hooks';

import type { EditorLockType } from '../../types/editor';
import type { Message } from '../../types/messages';
import type { WidgetTheme } from '../../types/theme';
import type { WidgetLocale } from '../../types/widgetLocale';
import type { WidgetMessages } from '../../types/widgetMessages';
import { getWidgetMessages } from '../../utils';

export interface WidgetContextProps {
  messages: Message[];
  setMessages?: Dispatch<SetStateAction<Message[]>>;
  files?: File[];
  setFiles?: Dispatch<SetStateAction<File[]>>;
  widgetTitle?: string;
  widgetTheme?: WidgetTheme;
  companyLogoSrc?: string;
  widgetUuid?: string;
  editorLock?: EditorLockType | null;
  entryPointGateway?: string;
  requirePhone?: boolean;
  hasMaxUserPhone?: boolean;
  setHasMaxUserPhone?: Dispatch<SetStateAction<boolean | undefined>>;
  setEditorLock?: Dispatch<SetStateAction<EditorLockType | null>>;
  error?: string | null;
  setError?: Dispatch<SetStateAction<string | null>>;
  hasNewMessage?: boolean;
  setHasNewMessage?: Dispatch<SetStateAction<boolean>>;
  hideTriggerButton?: boolean;
  locale: WidgetLocale;
  localeMessages: WidgetMessages;
}

export const WidgetContext = createContext<WidgetContextProps>({
  messages: [],
  locale: 'ru',
  localeMessages: getWidgetMessages('ru'),
});
